
import { nanoid } from "@/lib/utils.js";
import request from './index.jsx'
import axios from "axios";
import { createUploadProofLoader } from "./uploadProofState.js";
import { uploadedImageIdentity } from "../lib/uploadedImageIdentity.js";
import {v4 as uuid} from 'uuid'

export const OssFileType = {
  TEMP: 'TEMP',
  IMAGE: 'IMAGE',
  GROUP: 'GROUP',
  DOCUMENT: 'DOCUMENT',
  BATCH: 'BATCH',
  STATIC: 'STATIC',
}
// 获取上传凭证
export const getUploadCredentials = (query) => {
  return request.post(`/api/oss/getToken?fileType=${query.fileType}`, undefined, { silentError: true });
};

// 文件上传函数
export const uploadFileToOSS = async (files, ossConfig, onProgress, fileType = 'IMAGE', options = {}) => {

  const uploadRequests = [];
  for (let i = 0; i < files.length; i++) {
    const element = files[i];

    const formData = new FormData();
    var filename = ossConfig.keepFileName
      ? element.name
      : element.name ?
        (new Date().getTime() + "_" + element.name.replace(/^.*\.(.*)$/, (match, p1) => `${nanoid()}.${p1}`)) :
        (Date.now() + "_" + uuid());
    
    // 处理dir为null的情况，根据fileType设置目录
    let uploadDir = ossConfig.dir;
    if (!uploadDir || uploadDir === null || uploadDir === 'null') {
      // 根据fileType设置默认目录
      switch (fileType) {
        case 'STATIC':
          uploadDir = 'static/';
          break;
        case 'IMAGE':
          uploadDir = 'image/';
          break;
        case 'DOCUMENT':
          uploadDir = 'document/';
          break;
        case 'TEMP':
          uploadDir = 'temp/';
          break;
        case 'GROUP':
          uploadDir = 'group/';
          break;
        case 'BATCH':
          uploadDir = 'batch/';
          break;
        default:
          uploadDir = 'upload/';
      }
    }
    
    // 确保目录以/结尾
    if (uploadDir && !uploadDir.endsWith('/')) {
      uploadDir += '/';
    }
    
    const fileKey = uploadDir + filename;
    
    formData.append("Filename", filename);
    formData.append("key", fileKey.replace(/^\//, "")); // 移除开头的/
    formData.append("OSSAccessKeyId", ossConfig.accessId);
    formData.append("policy", ossConfig.policy);
    formData.append("Signature", ossConfig.signature);
    formData.append("success_action_status", options.returnObjectIdentity ? "201" : "200");
    
    // 根据fileType设置访问权限
    if (fileType === 'STATIC') {
      formData.append("x-oss-object-acl", "public-read"); // STATIC文件设置为公共读
    } else {
      formData.append("x-oss-object-acl", "private"); // 其他文件设置为私有
    }
    
    formData.append("file", element);
    const index = i
    // 确保OSS host使用HTTPS协议（如果当前页面是HTTPS）
    let ossHost = ossConfig.host;
    if (window.location.protocol === 'https:' && ossHost.startsWith('http://')) {
      ossHost = ossHost.replace('http://', 'https://');
    }
    
    const uploadRequest = axios.post(
        ossHost,
        formData,
        {
          signal: options.signal,
          timeout: options.timeout ?? 120000,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          responseType: "text",
          onUploadProgress: (progressEvent) => {
            if (typeof onProgress === 'function' && progressEvent.lengthComputable) {
              const complete = (progressEvent.loaded / progressEvent.total) * 100 | 0
              onProgress(index, complete)
            }
          }
        })
      .then(response => ({
        uid: nanoid(),
        status: "done",
        url: fileKey, // 使用正确的文件路径
        relativeUrl: fileKey,
        absolutePath: ossHost + "/" + fileKey, // 使用修正后的ossHost
        objectIdentity: options.returnObjectIdentity && response.status === 201
          ? uploadedImageIdentity(fileKey, response.data) : null,
      })).catch((err) => ({
        uid: nanoid(),
        status: "error",
        error: err.message,
      }));

    uploadRequests.push(uploadRequest);
  }
  // 使用Promise.all等待所有上传请求完成
  return Promise.all(uploadRequests);
};

export const getProof = createUploadProofLoader({
  requestProof: getUploadCredentials,
  storage: sessionStorage,
});
